import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { GalleryPage } from './pages/GalleryPage';
import { AssetDetailPage } from './pages/AssetDetailPage';
import { StatsPage } from './pages/StatsPage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<GalleryPage />} />
        <Route path="/asset/:id" element={<AssetDetailPage />} />
        <Route path="/stats" element={<StatsPage />} />
      </Route>
    </Routes>
  );
}
